import React, {useState, useEffect} from 'react';
import {Form, Button, Alert} from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import {Formik} from 'formik';
//Redirect
import axios from 'axios';
import {apiUrl} from '../../util/Api';
import LeftNav from '../../components/LeftNav';

//import {string, object} from 'yup';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  name: Yup.string().required('please enter your name'),
  email: Yup.string().email('please enter a valid email').required('email is required'),
  subject: Yup.string().required('please enter a subject'),
  message: Yup.string().required('please enter a message'),
});

const Support = () => {
  const [errors, setErrors] = useState([]);
  const [successMsgs, setSuccessMsgs] = useState([])
  const [showForm, setShowForm] = useState(true);
  const [referrer, setReferrer] = useState(null)

  let { accountKey } = useParams();

  useEffect(()=>{
    if(document.referrer) {
      setReferrer(document.referrer)
    }
    document.title = `reconify support`;
  },[])

  const submitForm = (values, actions) => {
    setErrors([]);
    setSuccessMsgs([]);

    if(referrer != null){
      values.referrer = referrer;
    }

    axios.post(apiUrl + '/support/send', values, {withCredentials: true})
    .then((res) => {
      if(res.data.status === "ok") {
        let successes = []
        successes.push('Thank you for your message.');
        successes.push('We will follow up shortly.')
        setSuccessMsgs(successes);
        setShowForm(false)
      }
      else {

        let errorMsgs = [];
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'email-missing':
              errorMsgs.push('Please enter an email.');
              break;
            case 'subject-missing':
              errorMsgs.push('Please enter a subject.');
              break;
            case 'message-missing':
              errorMsgs.push('Please enter a message.');
              break;
            default:
              errorMsgs.push('There was an error processing this request.');
          }
        });
        setErrors(errorMsgs);
      }
    })
    .catch((err) => {
      setErrors(['An error occured. Try again later.']);
    });
  }

  return (
    <div>
      <LeftNav accountKey={accountKey}/>
      <h3>Support</h3>
      {
        errors.length > 0 ? (
          <Alert variant='danger'>
          {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
          </Alert>
        ) : (null)
      }
      {
        successMsgs.length > 0 ? (
          <Alert variant='info'>
          {successMsgs.map((msg, i) => (<div key={'msg.' + i}>{msg}</div>))}
          </Alert>
        ) : (null)
      }
      { showForm ? (
        <>
        <p>
          Use the form below to send us a message.
        </p>
        <Formik validationSchema={validationSchema}
          onSubmit={submitForm}
          initialValues={{name:'', email:'', subject:'', message:''}}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors
          }) => (
            <Form noValidate onSubmit={handleSubmit} className='col-md-7 col-sm-8'>
              <Form.Group controlId='support-name' className='mb-3'>
                <Form.Label>Name <span className='required-field'>*</span></Form.Label>
                <Form.Control type="text" placeholder="name"
                  name="name" value={values.name} onChange={handleChange}
                  isInvalid={touched.name && errors.name}
                />
                <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId='support-email' className='mb-3'>
                <Form.Label>Email <span className='required-field'>*</span></Form.Label>
                <Form.Control type="email" placeholder="email"
                  name="email" value={values.email} onChange={handleChange}
                  isInvalid={touched.email && errors.email}
                />
                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId='support-subject' className='mb-3'>
                <Form.Label>Subject <span className='required-field'>*</span></Form.Label>
                <Form.Control type="text" placeholder="enter a subject"
                  name="subject" value={values.subject} onChange={handleChange}
                  isInvalid={touched.subject && errors.subject}
                />
                <Form.Control.Feedback type="invalid">{errors.subject}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId='support-message' className='mb-3'>
                <Form.Label>Message <span className='required-field'>*</span></Form.Label>
                <Form.Control as="textarea" rows={3} placeholder="Please let us know how we can help"
                  name="message" value={values.message} onChange={handleChange}
                  isInvalid={touched.message && errors.message}
                />
                <Form.Control.Feedback type="invalid">{errors.message}</Form.Control.Feedback>
              </Form.Group>

              <Button variant="primary" type="submit">Send</Button>
            </Form>
          )}
        </Formik>
        </>
      ) : (null)}

    </div>
  );
}


export default Support;
